import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { InteractiveText } from '@/packages/shared-ui';

type BackToListingButtonProps = {
  track(): void;
  onClick(): void;
};

export const BackToListingButton: FC<BackToListingButtonProps> = props => {
  const { onClick, track } = props;

  return (
    <InteractiveText behaviour="hover_primary_to_primary_hover" track={track} onClick={onClick}>
      <IconActionChevronLeft16 color="current_color" />
      &nbsp;Назад
    </InteractiveText>
  );
};
